<template>
  <v-card class="upload-image-dialog-card">
    <v-card-actions class="dialog-buttons-container">
      <v-btn text @click="handleCancelEditing" class="dialog-cancel-button">{{ $t("cancel") }}</v-btn>
      <v-btn text @click="handleSaveEdit" class="dialog-save-button">{{ $t("save_edit") }}</v-btn>
    </v-card-actions>
    <div class="image-edit-wrapper">
      <VueCropper
        :src="imageSrc"
        ref="cropper"
        class="image-edit-card"
        @ready="handleOnReady"
        :aspect-ratio="16 / 16"
        :background="false"
        :guides="true"
        :view-mode="0"
        :zoomable="false"
        drag-mode="move"
        :auto-crop-area="1"
        :autoCrop="false"
        :responsive="true"
      />
      <div class="image-edit-icons">
        <Button icon @click="cropInit()">
          <FIcon :name="'crop-image'" size="2.2rem" color="#000" />
        </Button>
        <Button icon @click="flipY(-1)">
          <FIcon :name="'flip-vertical-down'" size="2.2rem" color="#000" />
        </Button>
        <Button icon @click="flipY(1)">
          <FIcon :name="'flip-vertical-up'" size="2.2rem" color="#000" />
        </Button>
        <Button icon @click="flipX(-1)">
          <FIcon :name="'flip-horizontal-right'" size="2.2rem" color="#000" />
        </Button>
        <Button icon @click="flipX(1)">
          <FIcon :name="'flip-horizontal-left'" size="2.2rem" color="#000" />
        </Button>
      </div>
    </div>
  </v-card>
</template>

<script>
import { UploadImage } from "@/modules/input/image";
import { $eventHub } from "@/components";
import { EventConstraints } from "@/enums/events.enum";

export default {
  data: () => ({
    image: null,
    croppedImage: null,
    originalImage: null,
  }),

  props: {
    imageSrc: {
      type: String,
      default: null,
      required: true,
    },

    handleCancelEditing: {
      type: Function,
      default: null,
    },

    handleSaveEdit: {
      type: Function,
      default: null,
    },
  },

  methods: {
    /***
     * Initialize a new instant from image
     * @returns {void}
     */
    handleOnReady() {
      this.image = new UploadImage(this.$refs.cropper);
      this.clear();
      this.image.zoomTo(1);
    },

    /***
     * Rotate image
     * @returns {void}
     */
    rotate(deg) {
      this.image.rotate(deg);
    },

    /***
     * Flip the image within the x-axis
     * @returns {void}
     */
    flipX(scale) {
      this.image.flipX(scale);
    },

    /***
     * Flip the image within the y-axis
     * @returns {void}
     */
    flipY(scale) {
      this.image.flipY(scale);
    },

    /***
     * Crop the image
     * @returns {void}
     */
    cropImage() {
      this.croppedImage = this.image.cropImage();
      $eventHub.$emit(EventConstraints.UPLOAD_IMAGE_EVENT, this.croppedImage);
      this.clear();
    },

    /***
     * Reset the image state
     * @returns {void}
     */
    clear() {
      this.image.clear();
      this.image.reset();
    },

    /***
     * Initialize crop square on the image
     * @returns {void}
     */
    cropInit() {
      this.image.crop();
    },
  },
};
</script>

<style lang="scss" src="./styles.scss" scoped />
